import { render, staticRenderFns } from "./ObjectSelector.vue?vue&type=template&id=7ca1bfa5&scoped=true&"
import script from "./ObjectSelector.vue?vue&type=script&lang=ts&"
export * from "./ObjectSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ObjectSelector.vue?vue&type=style&index=0&id=7ca1bfa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca1bfa5",
  null
  
)

export default component.exports